import { useUIStore } from '@uofu-uss-gis/ui-react';
import { useAuthStore } from '../../store/authStore';
import { env } from '../../config/env';
import { loadOidcService } from '../../services/oidcLoader';
import { useTheme } from '@mui/material/styles';

const isLocalMode = env.localMode;

const MyClassesButton = () => {
  const { isAuthenticated } = useAuthStore();
  const { myClassesOpen, setMyClassesOpen } = useUIStore();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const handleClick = () => {
    if (isAuthenticated || isLocalMode) {
      setMyClassesOpen(true);
    } else {
      void loadOidcService().then(oidcService => oidcService?.login());
    }
  };

  if (myClassesOpen) {
    return null;
  }

  // Login icon (map-logout.svg) should NOT be inverted in dark mode
  // It should be inverted in light mode to make it visible
  // In dark mode, it should be normal (white) to show against dark background
  const shouldInvertLoginIcon = !isDark;

  return (
    <button
      type="button"
      className="hidden lg:block absolute top-20 right-4 shadow-lg rounded-lg cursor-pointer hover:shadow-xl transition-shadow z-40"
      style={{ backgroundColor: theme.palette.background.paper }}
      onClick={handleClick}
      aria-label={isAuthenticated ? 'Open My Classes' : 'Log in to My Classes'}
    >
      <div className="flex items-center gap-3 p-4 min-w-[200px]">
        <div className="w-8 h-8 flex-shrink-0">
          <img 
            src={!isAuthenticated ? "/app/resources/images/map-logout.svg" : "/app/resources/images/Ulogo.png"}
            alt="Login" 
            width={32}
            height={32}
            className={`${!isAuthenticated && shouldInvertLoginIcon ? "invert" : ""} w-full h-full`}
          />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold" style={{ color: theme.palette.text.primary }}>
            {isAuthenticated ? 'My Classes' : 'Log In'}
          </p>
        </div>
      </div>
    </button>
  );
};

export default MyClassesButton;
